exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".properties-choice-grid[data-v-109aeac1]{display:grid;grid-template-columns:.2fr .6fr .2fr;grid-gap:1rem}.properties-choice-grid button[data-v-109aeac1]{margin-top:35px}.error-msg[data-v-109aeac1]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-109aeac1","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/vendors/EditVendor.vue
// module id = aX05
// module chunks = 0 1